@import url('https://fonts.googleapis.com/css2?family=Press+Start+2P&display=swap');

:root {
  --bg-color: #1a1a24;
  --text-color: #e0e0e0;
  --accent-color: #ff3366;
  /* Sfondo della partita: stesso della lobby/collezione, così la board non
     sembra un'app diversa. Pannelli e bordi riprendono le card della lobby. */
  --board-color: var(--bg-color);
  --panel-color: #0c0c16;
  --panel-border: #2a2a3a;
  font-family: 'Press Start 2P', system-ui, sans-serif;
  line-height: 1.5;
  font-weight: 400;

  color-scheme: light dark;
  color: var(--text-color);
  background-color: var(--bg-color);

  font-synthesis: none;
  text-rendering: optimizeLegibility;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

/* Base Pixel-art rendering class */
.pixelated {
  image-rendering: pixelated;
  image-rendering: -moz-crisp-edges;
  image-rendering: crisp-edges;
}

body {
  margin: 0;
  padding: 0;
  display: flex;
  min-width: 320px;
  min-height: 100vh;
  justify-content: center;
  align-items: center;
  overflow: hidden;
}

/* I controlli dei form non ereditano il font dal browser: senza questa regola
   ogni bottone senza fontFamily esplicito usava il font di sistema. */
button, input, select, textarea {
  font-family: inherit;
}

h1, h2, h3 {
  letter-spacing: 2px;
}

#root {
  width: 100%;
  height: 100vh;
  display: flex;
  flex-direction: column;
}

.lobby-match-card {
  background: #222;
  padding: 10px;
  border-radius: 5px;
  font-size: 12px;
  position: relative;
  transition: transform 0.2s, background 0.2s;
}

.lobby-match-card:hover {
  background: #2a2a2a;
  transform: translateX(5px);
}

.delete-match-btn {
  background: transparent;
  border: none;
  color: #666;
  cursor: pointer;
  padding: 4px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: color 0.2s, background 0.2s;
}

.delete-match-btn:hover {
  color: var(--accent-color);
  background: rgba(255, 51, 102, 0.1);
}

/* --- New Loot Highlights & Badges --- */

.new-loot-glow-container .card {
  animation: pulse-glow 1.5s infinite alternate;
}

@keyframes pulse-dot {
  0% {
    transform: scale(0.85);
    opacity: 0.7;
  }
  100% {
    transform: scale(1.15);
    opacity: 1;
  }
}

@keyframes pulse-glow {
  0% {
    box-shadow: 0 0 4px rgba(57, 255, 20, 0.4);
    border-color: rgba(57, 255, 20, 0.6) !important;
  }
  50% {
    box-shadow: 0 0 16px rgba(57, 255, 20, 0.8), inset 0 0 8px rgba(57, 255, 20, 0.3);
    border-color: rgba(57, 255, 20, 1) !important;
  }
  100% {
    box-shadow: 0 0 4px rgba(57, 255, 20, 0.4);
    border-color: rgba(57, 255, 20, 0.6) !important;
  }
}

@keyframes pulse-text {
  0% {
    opacity: 0.6;
    text-shadow: 0 0 2px #39ff14;
  }
  100% {
    opacity: 1;
    text-shadow: 0 0 8px #39ff14;
  }
}

@keyframes pulse-badge {
  0% {
    transform: scale(0.95);
    box-shadow: 0 0 4px #39ff14;
  }
  100% {
    transform: scale(1.05);
    box-shadow: 0 0 12px #39ff14;
  }
}
